import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
const _excluded = ["doctor", "doctorsOptions", "handlePhysicianChange", "severity", "maxMenuHeight"],
      _excluded2 = ["roleGroup", "roleGroupOptions", "handleRoleGroupChange", "severity", "width"],
      _excluded3 = ["frequency", "frequencyOptions", "handleFrequencyChange", "severity", "width"],
      _excluded4 = ["period", "periodOptions", "handlePeriodChange", "severity", "width"],
      _excluded5 = ["value", "options", "handleLocTypeChange", "severity"],
      _excluded6 = ["value", "options", "handleFacilityChange", "severity", "maxMenuHeight"];
import React from 'react';
import { ReactDatePicker, ReactDateTimePicker } from '../../DatePicker';
import { SuggestBox } from '../../SuggestBox';
import { SuggestBoxWrapper, ExpandableSuggestBoxWrapper, ErrorText, ErrorBoxWrapper, OrderTypeStatement, OrderTypeWrapper } from '../layout/WrapperDiv';
import { boxWidth, infoWidth } from './constants';
import en from '../../translationDefaults/en';
export const ErrorLabel = ({
  errorLabel
}) => /*#__PURE__*/React.createElement(ErrorBoxWrapper, {
  width: boxWidth
}, errorLabel);
export const OrderType = ({
  orderName
}) => /*#__PURE__*/React.createElement(OrderTypeStatement, {
  id: "verify-verbal-date"
}, /*#__PURE__*/React.createElement(SuggestBoxWrapper, {
  width: infoWidth
}, en.verifyOrderType), /*#__PURE__*/React.createElement(OrderTypeWrapper, {
  width: boxWidth
}, orderName));
export default OrderType;
export const VerbalPicker = ({
  selectedDate,
  handleVerbalDateChange,
  severity,
  minimumDate,
  maximumDate,
  width,
  unsetPopperStyles
}) => /*#__PURE__*/React.createElement(SuggestBoxWrapper, {
  severity: severity,
  width: width || boxWidth,
  textAlign: "left",
  id: "verbal-picker"
}, /*#__PURE__*/React.createElement(ReactDatePicker, {
  popperPosition: unsetPopperStyles ? 'fixed' : '',
  popperPlacement: unsetPopperStyles ? 'top' : undefined,
  inputMargin: "2px",
  selectedDate: selectedDate,
  onChange: handleVerbalDateChange,
  minimumDate: minimumDate,
  maximumDate: maximumDate || new Date(),
  id: "progress-notes-picker"
}));
export const EffDatePicker = ({
  selectedDate,
  handleEffDateChange,
  severity,
  width,
  minimumDate,
  maximumDate,
  unsetPopperStyles,
  error,
  disabled
}) => /*#__PURE__*/React.createElement(SuggestBoxWrapper, {
  severity: severity,
  width: width || boxWidth,
  textAlign: "left"
}, /*#__PURE__*/React.createElement(ReactDatePicker, {
  inputMargin: "2px",
  popperPosition: unsetPopperStyles ? 'fixed' : '',
  popperPlacement: unsetPopperStyles ? 'top' : undefined,
  selectedDate: selectedDate,
  onChange: handleEffDateChange,
  minimumDate: minimumDate,
  maximumDate: maximumDate,
  id: "progress-notes-picker",
  disabled: disabled
}), !!error && /*#__PURE__*/React.createElement(ErrorText, null, error));
export const EffDateTimePicker = ({
  selectedDate,
  handleEffDateChange,
  severity,
  width,
  minimumDate,
  maximumDate,
  unsetPopperStyles
}) => /*#__PURE__*/React.createElement(SuggestBoxWrapper, {
  severity: severity,
  width: width
}, /*#__PURE__*/React.createElement(ReactDateTimePicker, {
  popperPosition: unsetPopperStyles ? 'fixed' : '',
  popperPlacement: unsetPopperStyles ? 'top' : undefined,
  inputWidth: "140px",
  inputMargin: "2px",
  selectedDate: selectedDate,
  onChange: handleEffDateChange,
  minimumDate: minimumDate,
  maximumDate: maximumDate,
  minimumTime: minimumDate || undefined,
  maximumTime: maximumDate || undefined,
  id: "progress-notes-picker"
}));
export const PhysicianPicker = _ref => {
  let {
    doctor,
    doctorsOptions,
    handlePhysicianChange,
    severity,
    maxMenuHeight
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(ExpandableSuggestBoxWrapper, {
    severity: severity,
    width: boxWidth
  }, /*#__PURE__*/React.createElement(SuggestBox, _extends({
    inputId: "physician-notes",
    editablePlaceholder: true,
    fitcontent: true,
    placeholder: en.physician,
    options: doctorsOptions,
    onChange: handlePhysicianChange,
    value: doctor,
    menuPlacement: "top",
    noMaxHeight: true,
    maxMenuHeight: maxMenuHeight || 300
  }, props)));
};
export const RoleGroupPicker = _ref2 => {
  let {
    roleGroup,
    roleGroupOptions,
    handleRoleGroupChange,
    severity,
    width
  } = _ref2,
      props = _objectWithoutProperties(_ref2, _excluded2);

  return /*#__PURE__*/React.createElement(SuggestBoxWrapper, {
    severity: severity,
    width: width || boxWidth
  }, /*#__PURE__*/React.createElement(SuggestBox, _extends({
    inputId: "role-group-picker",
    editablePlaceholder: true,
    fitcontent: true,
    placeholder: en.roleGroup,
    options: roleGroupOptions,
    onChange: handleRoleGroupChange,
    value: roleGroup
  }, props)));
};
export const FrequencyPicker = _ref3 => {
  let {
    frequency,
    frequencyOptions,
    handleFrequencyChange,
    severity,
    width
  } = _ref3,
      props = _objectWithoutProperties(_ref3, _excluded3);

  return /*#__PURE__*/React.createElement(SuggestBoxWrapper, {
    severity: severity,
    width: width || boxWidth
  }, /*#__PURE__*/React.createElement(SuggestBox, _extends({
    inputId: "role-group-frequency",
    editablePlaceholder: true,
    fitcontent: true,
    placeholder: en.frequency,
    options: frequencyOptions,
    onChange: handleFrequencyChange,
    value: frequency
  }, props)));
};
export const PeriodPicker = _ref4 => {
  let {
    period,
    periodOptions,
    handlePeriodChange,
    severity,
    width
  } = _ref4,
      props = _objectWithoutProperties(_ref4, _excluded4);

  return /*#__PURE__*/React.createElement(SuggestBoxWrapper, {
    severity: severity,
    width: width || boxWidth
  }, /*#__PURE__*/React.createElement(SuggestBox, _extends({
    inputId: "role-group-period",
    editablePlaceholder: true,
    fitcontent: true,
    placeholder: en.period,
    options: periodOptions,
    onChange: handlePeriodChange,
    value: period
  }, props)));
};
export const LOCPicker = _ref5 => {
  let {
    value,
    options,
    handleLocTypeChange,
    severity
  } = _ref5,
      props = _objectWithoutProperties(_ref5, _excluded5);

  return /*#__PURE__*/React.createElement(SuggestBoxWrapper, {
    severity: severity,
    width: boxWidth
  }, /*#__PURE__*/React.createElement(SuggestBox, _extends({
    inputId: "admit-loc",
    editablePlaceholder: true,
    fitcontent: true,
    placeholder: en.chooseloc,
    options: options,
    onChange: handleLocTypeChange,
    value: value
  }, props)));
};
export const FacilityPicker = _ref6 => {
  let {
    value,
    options,
    handleFacilityChange,
    severity,
    maxMenuHeight
  } = _ref6,
      props = _objectWithoutProperties(_ref6, _excluded6);

  return /*#__PURE__*/React.createElement(ExpandableSuggestBoxWrapper, {
    severity: severity,
    width: 230
  }, /*#__PURE__*/React.createElement(SuggestBox, _extends({
    menuPlacement: "top",
    noMaxHeight: true,
    inputId: "facility-name",
    editablePlaceholder: true,
    fitcontent: true,
    placeholder: en.facility,
    options: options,
    onChange: handleFacilityChange,
    value: value,
    maxMenuHeight: maxMenuHeight || 300
  }, props)));
};
export const DischargePicker = ({
  value,
  options,
  handleDischargeChange,
  severity
}) => /*#__PURE__*/React.createElement(SuggestBoxWrapper, {
  severity: severity,
  width: boxWidth
}, /*#__PURE__*/React.createElement(SuggestBox, {
  inputId: "discharge-reason",
  editablePlaceholder: true,
  fitcontent: true,
  placeholder: en.dischargeReason,
  options: options,
  onChange: handleDischargeChange,
  value: value
}));
export const ConversationPicker = ({
  value,
  options,
  handleConversationChange,
  severity
}) => /*#__PURE__*/React.createElement(SuggestBoxWrapper, {
  width: 130
}, /*#__PURE__*/React.createElement(SuggestBox, {
  inputId: "conversation-type",
  editablePlaceholder: true,
  fitcontent: true,
  placeholder: value,
  options: options,
  onChange: handleConversationChange,
  value: value
}));